module.exports = __webpack_public_path__ + "static/media/features-split-image-05.777b0cc1.jpg";